// src/landing/Hero.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Hero = () => {
  const { isAuthenticated } = useAuth();
  
  return (
    <div className="bg-blue-500 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-bold sm:text-5xl lg:text-6xl">
          Ace Your Study Journey
        </h1>
        <p className="mt-6 text-xl max-w-3xl mx-auto">
          Track your progress, stay focused, and achieve your academic goals
        </p>
        <div className="mt-10">
          <Link
            to={isAuthenticated ? "/dashboard" : "/signup"}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg inline-block transition-colors"
          >
            {isAuthenticated ? "Go to Dashboard →" : "Get Started Now →"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hero;